//https://stackoverflow.com/questions/71086276/typeerror-u-readfile-is-not-a-function-in-angular
import React from 'react';
import jsPDF from "jspdf"
import autoTable from 'jspdf-autotable'
import { subdir, wwwdir, logo, logowww } from "./logo";
// import { Link } from 'react-router-dom';

const ExportToPdf = ({ data, cicle, yyear }) => {

  const exportExcel = async () => {

    // console.log(data)

    var ciclo = cicle
    // this.loading = "false"
    const doc = new jsPDF({
      // orientation: "landscape",
      // unit: "in",
      // format: [4, 2]
    })

    const indice = data.map(e => e._id).indexOf(cicle)
    var cntr = doc.internal.pageSize.width / 2
    // doc.table(10, 10, data, header, config);
    console.log(data[indice].mencions[0], cicle)
    console.log(indice)
    var users = data[indice].mencions[0].cycles
    var credito = 0
    var nota = 0
    var neww = []
    for (var i = 0; i < users.length; i++) {
      if (users[i].ciclo === ciclo) {
        var www = [users[i].title, users[i].year, users[i].credito, users[i].nota, users[i].credito * users[i].nota]//.concat(calification)
        neww.push(www);
        nota += + users[i].nota * users[i].credito
        credito += + users[i].credito
      }
    }

    // var foto2 = new Image()
    // foto2.src = './logo.png'
    // doc.addImage(foto2, 'png', doc.internal.pageSize.width - 53, 27.7, 32.5, 32.5)

    doc.setLineWidth(16)
    doc.setDrawColor(255, 255, 255);
    // doc.setFillColor(255, 0, 0)
    doc.circle(2 * cntr - 36.9, 43.9, 23.5, 'S')
    doc.setLineWidth(0);
    doc.setDrawColor(0)

    autoTable(doc, {
      margin: { horizontal: 12, top: 59 },
      startY: 0.25 * doc.internal.pageSize.height,
      styles: { overflow: 'linebreak' },
      styles: { fillColor: 'wheat' },
      columnStyles: { 0: { halign: 'center' } },
      //fillColor: [255, 255,   250] }  Cells in first column centered and green
      // margin: { top: 59 },
      head: [['CURSO', 'AÑO', 'CRÉDITO', 'NOTA', 'PUNTAJE']],
      foot: [["TOTAL", "",  credito, "", nota],
      ["PROMEDIO SEMESTRAL", "", "", "", (nota / credito).toFixed(2)]
      ],
      body: neww,
    })

    var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre']


    doc.setFontSize(18)
    // doc.setTextColor(1, 198, 255);
    doc.text("BOLETA DE NOTAS SEMESTRAL", cntr, 29, { align: 'center' });
    doc.setFontSize(16)
    doc.text(`CICLO ${ciclo}`, cntr, 36, { align: 'center' });
    doc.setFontSize(12)
    doc.setTextColor(0, 0, 0);
    doc.text("Escuela Superior de Bellas Artes Publica Ayacucho", cntr, 43, { align: 'center' });
    doc.setFontSize(9)
    doc.text("ESFAP 'FELIPE GUAMÁN POMA DE AYALA'", cntr, 48, { align: 'center' });
    doc.setFontSize(7)
    doc.text('Ayacucho, ' + new Date().getDate() + ' de ' + meses[new Date().getMonth()] + ' del ' + new Date().getFullYear(), cntr, 51, { align: 'center' });
    doc.setFontSize(12)
    doc.setTextColor(0, 0, 0);


    doc.text(JSON.parse(localStorage.getItem("user")).name, cntr, 59, { align: 'center' });
    doc.text(JSON.parse(localStorage.getItem("user")).mencion === 'P' ? "ARTES PLÁSTICAS (Pintura)" : JSON.parse(localStorage.getItem("user")).mencion === 'E' ? "ARTES PLÁSTICAS (Escultura)" :
      JSON.parse(localStorage.getItem("user")).mencion === 'G' ? "ARTES PLÁSTICAS  Y VISUALES (Grabado)" : "ARTES PLÁSTICAS Y VISUALES (Educación Artística)", cntr, 65, { align: 'center' });

    var imgData = 'data:image/jpeg;base64,' + subdir
    doc.addImage(imgData, 'jpeg', cntr - 21, 235, 95, 37, "", 'NONE', -5)
    var imgData2 = 'data:image/jpeg;base64,' + wwwdir
    doc.addImage(imgData2, 'png', cntr - 65, 205, 89.8, 39, "", 'NONE', 19)

    // var img3 = new Image()
    // img3.src = './esfap.jpg'
    // img3.onload = function () {
      // doc.addImage(img3, 'jpg', 21, 28.8, 35, 31)
      doc.save(JSON.parse(localStorage.getItem("user")).name + " Calificaciones del ciclo " + ciclo + ".pdf");
    // }
  }

  return (
    <>
      <button onClick={exportExcel} className='btn btn-info'>Imprimir boleta {cicle} {yyear}</button>
    </>
  )
}

export default ExportToPdf





